import Loadable from "@cores/loadable";

const LoadableVideoPlayer = Loadable({
    loader: () => import('./VideoPlayer'),
    loading: () => null
});

export default LoadableVideoPlayer;
